import script from "./certificatePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./certificatePreview.vue?vue&type=script&setup=true&lang=js"

import "./certificatePreview.vue?vue&type=style&index=0&id=59cf516a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59cf516a"]])

export default __exports__